<template>
	<b-modal
		hide-footer
		ref="modal-view"
		size="lg"
		:title="modelId > 0 ? $t(modalTitleEdit) : $t(modalTitleNew)"
	>
		<b-card no-body>
			<b-tabs no-fade pills card small :vertical="vertical" nav-class="nav-style">
				<b-tab title="General" active>
					<b-overlay :show="loading" no-wrap></b-overlay>
					<b-form @submit="onSubmit">
						<FormGroupBox :title="$t('global.info')">
							<b-form-row>
								<b-form-group
									class="col-6"
									:label="$t('users.firstName')"
								>
									<b-form-input
										type="text"
										size="sm"
										v-model="modelInfo.firstName"
										required
									/>
								</b-form-group>
								<b-form-group
									class="col-6"
									:label="$t('users.lastName')"
								>
									<b-form-input
										type="text"
										size="sm"
										v-model="modelInfo.lastName"
										required
									/>
								</b-form-group>
							</b-form-row>
							<b-form-row>
								<b-form-group
									class="col-6"
									:label="$t('users.email')"
								>
									<b-form-input
										type="email"
										size="sm"
										v-model="modelInfo.email"
										required
									/>
								</b-form-group>
								<b-form-group
									class="col-6"
									:label="$t('users.phone')"
								>
									<b-form-input
										type="text"
										size="sm"
										v-model="modelInfo.phone"
									/>
								</b-form-group>
							</b-form-row>
							<b-form-row>
								<b-form-group
									class="col-4"
									:label="$t('users.language')"
								>
									<b-form-select
										size="sm"
										v-model="modelInfo.lang"
										:options="langOptions"
									></b-form-select>
								</b-form-group>
								<b-form-group
									class="col-4"
									:label="$t('users.access')"
								>
									<b-form-select
										size="sm"
										v-model="modelInfo.accessType"
										:options="accessTypeOptions"
									></b-form-select>
								</b-form-group>
								<b-form-group
									class="col-4"
									:label="$t('users.status')"
								>
									<b-form-select
										size="sm"
										v-model="modelInfo.status"
										:options="statusOptions"
									></b-form-select>
								</b-form-group>
							</b-form-row>
							<b-form-row
								v-if="modelInfo.accessType === 'driver'"
							>
								<b-form-group
									class="col-6"
									:label="$t('users.license')"
								>
									<b-form-input
										type="text"
										size="sm"
										v-model="modelInfo.licenseNumber"
									/>
								</b-form-group>

								<b-form-group class="col-6" label="Tarjeta de Identificación Aeroportuaria">
									<b-form-checkbox
										id="tia"
										v-model="modelInfo.tia"
										name="tia"
										value="true"
										unchecked-value="false"
										> El conductor cuenta con <strong>TIA</strong>
									</b-form-checkbox>
								</b-form-group>
							</b-form-row>
							<hr />
							<b-form-row v-if="modelId <= 0">
								<b-form-group
									class="col-6"
									:label="$t('users.password')"
								>
									<b-form-input
										type="text"
										size="sm"
										v-model="modelInfo.password"
									/>
								</b-form-group>
							</b-form-row>
						</FormGroupBox>
						<div class="text-right">
							<b-button variant="primary" type="submit">{{
								modelId > 0
									? $t("global.update")
									: $t("global.save")
							}}</b-button>
						</div>
					</b-form>
				</b-tab>
				<b-tab
					:title="$t('users.profile')"
					v-if="modelId > 0 && modelInfo.accessType === 'driver'"
				>
					<FilesRelated
						:model-id="modelId"
						model-reference="users"
						unable-delete
						:file-keys="[
							{
								label: $t('users.profilePicture'),
								keyName: 'profilePicture'
							}
						]"
					/>
				</b-tab>
			</b-tabs>
		</b-card>
	</b-modal>
</template>

<script>
import FormGroupBox from "../../helpers/FormGroupBox.vue";
import FilesRelated from "@/components/helpers/FilesRelated";
import Resize from "../../helpers/Resize.js";

export default {
	mixins: [Resize],
	props: {
		successCallback: {
			type: Function,
			required: false,
			default: () => {}
		}
	},
	components: {
		FormGroupBox,
		FilesRelated
	},
	data() {
		let defaultModelInfo = {
			id: -1,
			firstName: "",
			lastName: "",
			email: "",
			phone: "",
			supplierId: null,
			status: "active",
			licenseNumber: "",
			app: "sass",
			password:'',
			lang: "es",
			accessType: "operation",
			tia: false
		};
		return {
			modalTitleNew:'users.newUser',
			modalTitleEdit:'users.editingUser',
			modelId: -1,
			modelInfo: { ...defaultModelInfo },
			defaultModelInfo: { ...defaultModelInfo },
			loading: true,
			appOptions: [
				{ value: "core", text: "Shuttle Central Admin" },
				{ value: "suppliers", text: "Suppliers App" }
			]
		};
	},
	computed: {
		statusOptions: function() {
			return this.generateObject(this.$t("statusActive"));
		},
		accessTypeOptions: function() {
			return this.generateObject(this.$t("accessTypes"));
		},
		langOptions: function() {
			return this.generateObject(this.$t("langOptions"));
		}
	},
	methods: {
		generateObject(elm) {
			const optios = [];
			Object.keys(elm).forEach(item => {
				optios.push({ value: item, text: elm[item] });
			});
			return optios;
		},
		onSubmit(event) {
			event.preventDefault();
			if (this.$listeners.submit) {
				this.$listeners.submit(event);
				return;
			}
			this.loading = true;
			let rParams = {
				url: this.modelId > 0 ? `/users/${this.modelId}` : "/users",
				method: this.modelId > 0 ? "put" : "post"
			};

			rParams["data"] = this.modelInfo;
			this.$root.api
				.request(rParams)
				.then(res => {
					this.$root.showAlert(
						rParams.method == "post"
							? this.$t('users.msgRegistered')
							: this.$t('users.msgUpdate')
					);
					if (res.data.id) this.loadModel(res.data.id);
					this.successCallback(res);
				})
				.catch(this.$root.handleRequestError)
				.then(() => {
					this.loading = false;
				});
		},
		loadModel(id) {
			this.$root.auxVars.loadResourcesOpts({vm: this,resourceNames: ["userDriverOpts"], forceRefresh: true});
			this.modelId = id;
			this.$refs["modal-view"].show();
			this.fetchModel();
		},
		setAccessType(accessType) {
			this.modelInfo.accessType = accessType;
			if (accessType == 'driver') {
				this.modalTitleNew = 'users.newDriver'
				this.modalTitleEdit = 'users.editingDriver'
			}else{
				this.modalTitleNew = 'users.newUser'
				this.modalTitleEdit = 'users.editingUser'
			}
		},
		fetchModel() {
			if (this.modelId > 0) {
				this.loading = true;
				this.$root.api
					.get(`/users/${this.modelId}`)
					.then(res => {
						this.modelInfo = { ...res.data };
						this.setAccessType(this.modelInfo.accessType)
						this.loading = false;
						//this.$root.auxVars.loadResourcesOpts(this,['userDriverOpts']);
					})
					.catch(this.$root.handleRequestError);

			} else {
				this.modelInfo = { ...this.defaultModelInfo };
				this.loading = false;
			}
		}
	},
	mounted() {
		console.log("mounted single");
	}
};
</script>

<style></style>
